import React from 'react';
import dayjs from "dayjs";

const EventMessage = (props: { item: any }) => {
    const payload = atob(props.item.body.replace('base64;', ''))
    return (
        <div className={'flex items-center justify-center my-2'}>
            <span
                className={'bg-[#dfdfdf] text-[#3f3f3f] px-3 text-sm rounded-full py-1'}>{payload} | {dayjs(props.item.createdAt).format('DD-MMM-YYYY HH:mm')}</span>
        </div>
    );
};

export default EventMessage;
